(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ReportExecuteSearch', ReportExecuteSearch);

    ReportExecuteSearch.$inject = ['$resource'];

    function ReportExecuteSearch($resource) {
        var resourceUrl =  'api/_search/report-executes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
